export function nombreAdjuntoGuardado(adjunto) {
  if (!adjunto) {
    return "Adjunto";
  }
  if (adjunto.nombre) {
    return adjunto.nombre;
  }
  const link = String(adjunto.link || adjunto.url || "");
  const partes = link.split("?")[0].split("/");
  return partes.pop() || "Adjunto";
}

export function urlAdjuntoGuardado(adjunto) {
  if (!adjunto) {
    return "";
  }
  if (adjunto.url) {
    return adjunto.url;
  }
  const link = String(adjunto.link || "").trim();
  if (!link) {
    return "";
  }
  if (/^https?:\/\//i.test(link)) {
    return link;
  }
  const base = (
    process.env.VUE_APP_AWS_BUCKET_URL ||
    process.env.VUE_APP_API_URL ||
    ""
  ).replace(/\/$/, "");
  const ruta = link.replace(/^\//, "");
  return base ? base + "/" + ruta : "/" + ruta;
}

export function extensionAdjuntoNombre(nombre) {
  const partes = String(nombre || "").split(".");
  if (partes.length < 2) {
    return "";
  }
  return partes.pop().toLowerCase();
}

export function iconoAdjuntoPorNombre(nombre) {
  const extension = extensionAdjuntoNombre(nombre);
  if (["jpg", "jpeg", "png"].includes(extension)) {
    return "fas fa-file-image";
  }
  if (extension === "pdf") {
    return "fas fa-file-pdf";
  }
  if (["xls", "xlsx"].includes(extension)) {
    return "fas fa-file-excel";
  }
  if (["doc", "docx"].includes(extension)) {
    return "fas fa-file-word";
  }
  if (extension === "csv") {
    return "fas fa-file-csv";
  }
  return "fas fa-file";
}

const MAX_ADJUNTOS = 5;
const MAX_TAMANO_ADJUNTO = 5 * 1024 * 1024;
const EXTENSIONES_ADJUNTO = [
  "jpg",
  "jpeg",
  "png",
  "pdf",
  "xls",
  "xlsx",
  "doc",
  "docx",
  "csv",
];

export default {
  data() {
    return {
      adjuntos: [],
      erroresAdjuntos: [],
      arrastrandoAdjuntos: false,
      maxAdjuntos: MAX_ADJUNTOS,
    };
  },

  methods: {
    abrirSelectorAdjuntos() {
      if (this.adjuntos.length >= MAX_ADJUNTOS) {
        this.erroresAdjuntos = ["Solo puede adjuntar 5 archivos."];
        return;
      }
      this.$refs.adjuntosInput.click();
    },

    seleccionarAdjuntos(event) {
      this.agregarAdjuntos(event.target.files);
      event.target.value = "";
    },

    soltarAdjuntos(event) {
      this.arrastrandoAdjuntos = false;
      this.agregarAdjuntos(event.dataTransfer.files);
    },

    salirZonaAdjuntos(event) {
      if (
        event.relatedTarget &&
        event.currentTarget.contains(event.relatedTarget)
      ) {
        return;
      }
      this.arrastrandoAdjuntos = false;
    },

    agregarAdjuntos(lista) {
      const archivos = Array.from(lista || []);
      const errores = [];
      const siguientes = this.adjuntos.slice();
      let cupoAvisado = false;

      archivos.forEach((archivo) => {
        const extension = this.extensionAdjunto(archivo.name);
        if (!EXTENSIONES_ADJUNTO.includes(extension)) {
          errores.push(archivo.name + " no tiene un formato permitido.");
          return;
        }

        if (!archivo.size) {
          errores.push(archivo.name + " está vacío.");
          return;
        }

        if (archivo.size > MAX_TAMANO_ADJUNTO) {
          errores.push(archivo.name + " supera los 5 MB.");
          return;
        }

        const repetido = siguientes.some(
          (item) => item.name === archivo.name && item.size === archivo.size
        );
        if (repetido) {
          errores.push(archivo.name + " ya está adjunto.");
          return;
        }

        if (siguientes.length >= MAX_ADJUNTOS) {
          if (!cupoAvisado) {
            errores.push("Solo puede adjuntar 5 archivos.");
            cupoAvisado = true;
          }
          return;
        }

        siguientes.push(archivo);
      });

      this.adjuntos = siguientes;
      this.erroresAdjuntos = errores;
    },

    quitarAdjunto(index) {
      this.adjuntos.splice(index, 1);
      this.erroresAdjuntos = [];
    },

    limpiarAdjuntos() {
      this.adjuntos = [];
      this.erroresAdjuntos = [];
      this.arrastrandoAdjuntos = false;
      if (this.$refs.adjuntosInput) {
        this.$refs.adjuntosInput.value = "";
      }
    },

    formDataAdjuntos(campos) {
      const datos = new FormData();
      Object.keys(campos).forEach((clave) => {
        const valor = campos[clave];
        if (typeof valor === "boolean") {
          datos.append(clave, valor ? "1" : "0");
          return;
        }
        if (valor === null || valor === undefined || valor === "") {
          return;
        }
        datos.append(clave, valor);
      });
      this.adjuntos.forEach((archivo) => {
        datos.append("adjuntos[]", archivo);
      });
      return datos;
    },

    extensionAdjunto(nombre) {
      return extensionAdjuntoNombre(nombre);
    },

    nombreAdjuntoGuardado,
    urlAdjuntoGuardado,

    iconoAdjunto(archivo) {
      return iconoAdjuntoPorNombre(
        archivo && archivo.name ? archivo.name : archivo
      );
    },

    formatearPeso(bytes) {
      if (bytes < 1024) {
        return bytes + " B";
      }
      if (bytes < 1024 * 1024) {
        return Math.round(bytes / 1024) + " KB";
      }
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    },
  },
};
